"use strict";

exports.DEFAULT_COLORS = {
  neutral: {
    white: "#fff",
    grayLight30: "#f8fafc",
    grayLight3: "#f8fafc",
    grayLight20: "#edf0f3",
    grayLight2: "#edf0f3",
    grayLight10: "#d5d5d5",
    grayLight1: "#d5d5d5",
    grayLight05: "#bebebe",
    gray: "#8a8a8a",
    grayDark05: "#BEBEBE",
    grayDark10: "#696969",
    grayDark1: "#696969",
    grayDark20: "#4a4a4a",
    grayDark2: "#4a4a4a",
    grayDark30: "#2c2c2c",
    grayDark3: "#2c2c2c",
    black: "#000"
  },
  blue: {
    blueLight30: "#7896b5",
    blueLight20: "#1570bc",
    blueLight2: "#1570bc",
    blueLight10: "#005b9c",
    blueLight1: "#005b9c",
    blue: "#0e497b",
    blueDark10: "#092e4e",
    blueDark1: "#092e4e",
    blueDark20: "#041320",
    blueDark2: "#041320"
  },
  gold: {
    goldLight30: "#faecce",
    goldLight3: "#faecce",
    goldLight20: "#f9d89e",
    goldLight2: "#f9d89e",
    goldLight10: "#ffc74c",
    goldLight1: "#ffc74c",
    gold: "#ffb81c",
    goldDark10: "#e79900",
    goldDark1: "#e79900",
    goldDark20: "#d18700",
    goldDark2: "#d18700"
  },
  sky: {
    skyLight10: "#c2eaf9",
    skyLight1: "#c2eaf9",
    skyLight05: "#99d8ee",
    sky: "#83d4f1",
    skyDark10: "#76c2ef",
    skyDark1: "#76c2ef"
  },
  teal: {
    tealLight20: "#ccefee",
    tealLight2: "#ccefee",
    tealLight10: "#76cdc8",
    tealLight1: "#76cdc8",
    teal: "#009e92",
    tealDark10: "#24a097",
    tealDark1: "#24a097"
  },
  red: {
    redLight20: "#ff979e",
    redLight2: "#ff979e",
    redLight10: "#fc5742",
    redLight1: "#fc5742",
    red: "#f52a01",
    redDark10: "#c12101",
    redDark1: "#c12101",
    redDark20: "#8e1801",
    redDark2: "#8e1801"
  },
  green: {
    greenLight20: "#41e88a",
    greenLight2: "#41e88a",
    greenLight10: "#00d15b",
    greenLight1: "#00d15b",
    green: "#00a046",
    greenDark10: "#006b2f",
    greenDark1: "#006b2f",
    greenDark20: "#003819",
    greenDark2: "#003819"
  },
  brand: {
    nm: {
      primary: {
        blue: "#0e497b"
      },
      secondary: {
        gold: "#ffb81c",
        sky: "#83d4f1",
        teal: "#009e92",
        orange: "#f36f35"
      }
    },
    pcg: {
      gold1: "#e1c88f",
      gold2: "#f2dfac",
      lightBlue1: "#105fcc",
      darkBlue1: "#0f1117",
      darkBlue2: "#0f2160",
      darkBlue3: "#00487c",
      darkBlue4: "#2f3d66",
      darkBlue5: "#26345f",
      gray: "#949494"
    }
  },
  background: {
    lightTheme: {
      heroLazyLoad: "#edf0f3",
      lightA: "#fff",
      lightB: "#f8fafc",
      lightC: "#edf0f3",
      lightSky: "#76c2ef",
      texture: {
        blue: "#0e497b"
      }
    },
    darkTheme: {
      darkDefault: "#0e497b",
      heroLazyLoad: "#4a4a4a",
      texture: {
        sky: "#83d4f1"
      }
    }
  },
  text: {
    lightTheme: {
      "default": "#2c2c2c",
      defaultHeading: "#4a4a4a",
      disabled: "#696969",
      error: "#c12101",
      success: "#00a046"
    },
    darkTheme: {
      "default": "#fff",
      disabled: "#d5d5d5",
      error: "#ff979e",
      success: "#00d15b"
    }
  },
  action: {
    lightTheme: {
      ctaTextDefault: "#fff",
      ctaTextDisabled: "#696969",
      ctaBgDefault: "#1570bc",
      ctaBgHover: "#005b9c",
      ctaBgActive: "#0e497b",
      ctaBgDisabled: "#d5d5d5",
      ctaBgSecondary: "transparent",
      ctaBgSecondaryHover: "rgba(0, 91, 156, 0.05)",
      ctaBgSecondaryActive: "rgba(14, 73, 123, 0.1)",
      ctaBgTertiary: "transparent",
      linkDefault: "#1570bc",
      linkVisited: "#1570bc",
      linkHover: "#005b9c",
      linkActive: "#1570bc",
      linkSecondaryDefault: "#4a4a4a",
      linkSecondaryVisited: "#4a4a4a",
      linkSecondaryHover: "#000",
      linkSecondaryActive: "#4a4a4a",
      utilityItemDefault: "#4a4a4a",
      utilityItemHover: "#1570bc",
      utilityItemActive: "#000"
    },
    darkTheme: {
      ctaTextDefault: "#000",
      ctaTextDisabled: "#696969",
      ctaTextSecondary: "#fff",
      ctaTextTertiary: "#fff",
      ctaTextTertiaryDisabled: "#d5d5d5",
      ctaBgDefault: "#ffb81c",
      ctaBgHover: "#e79900",
      ctaBgActive: "#d18700",
      ctaBgDisabled: "#d5d5d5",
      ctaBgSecondary: "transparent",
      ctaBgSecondaryHover: "rgba(255, 255, 255, 0.11)",
      ctaBgSecondaryActive: "rgba(255, 255, 255, 0.22)",
      ctaBgTertiary: "transparent",
      linkDefault: "#83d4f1",
      linkVisited: "#83d4f1",
      linkHover: "#fff",
      linkActive: "#83d4f1",
      linkSecondaryDefault: "#fff",
      linkSecondaryVisited: "#fff",
      linkSecondaryHover: "#fff",
      linkSecondaryActive: "#fff",
      utilityItemDefault: "#fff",
      utilityItemHover: "#83d4f1",
      utilityItemActive: "#fff"
    }
  },
  forms: {
    lightTheme: {
      inputFieldText: "#4a4a4a",
      inputFieldBg: "transparent",
      inputFieldSelectBg: "#f8fafc",
      inputFieldActive: "#1570bc",
      inputFieldError: "#c12101"
    },
    darkTheme: {
      inputFieldText: "#fff",
      inputFieldBg: "rgba(255, 255, 255, 0.08)",
      inputFieldError: "#ff979e"
    }
  },
  stroke: {
    lightTheme: {
      print: "#000",
      tableBorder: "#bebebe"
    },
    darkTheme: {
      tableBorder: "#fff"
    }
  }
};